import BlockType from '../enums/blockType';
import { toAlphaLabel } from '../pages/quotations/views/blocks/utils/alphaIndexUtil';
import { Block } from '../types/shared/blocks';

function getBlockLabel(blocks: Block[], block: Block) {
	let label;

	switch (block.type) {
		case BlockType.DECKBOX: {
			const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
			const lastBlock = deckboxes.pop();

			if (lastBlock) {
				const lastBlockLetter = lastBlock?.label?.split(/\s/)?.[1];
				const nextLetter = toAlphaLabel(letterToNumber(lastBlockLetter) + 1);

				label = `DeckBox ${nextLetter}`;
			} else {
				label = `DeckBox ${toAlphaLabel(0)}`;
			}

			break;
		}
		case BlockType.LANDING: {
			const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
			const landings = deckboxes.flatMap((dk) => dk.landings);

			const lastBlock = landings.pop();

			if (lastBlock) {
				const lastBlockLetter = lastBlock?.label?.split(/\s/)?.[1];
				const nextLetter = toAlphaLabel(letterToNumber(lastBlockLetter) + 1);

				label = `Landing ${nextLetter}`;
			} else {
				label = `Landing ${toAlphaLabel(0)}`;
			}

			break;
		}
		case BlockType.STAIR: {
			const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
			const stairs = deckboxes.flatMap((dk) => dk.stairs);

			const lastBlock = stairs.pop();

			if (lastBlock) {
				const lastBlockLetter = lastBlock?.label?.split(/\s/)?.[1];
				const nextLetter = toAlphaLabel(letterToNumber(lastBlockLetter) + 1);

				label = `Stair ${nextLetter}`;
			} else {
				label = `Stair ${toAlphaLabel(0)}`;
			}

			break;
		}
		case BlockType.BUMPOUT: {
			const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
			const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

			const lastBlock = bumpouts.pop();

			if (lastBlock) {
				const lastBlockLetter = lastBlock?.label?.split(/\s/)?.[1];
				const nextLetter = toAlphaLabel(letterToNumber(lastBlockLetter) + 1);

				label = `Bumpout ${nextLetter}`;
			} else {
				label = `Bumpout ${toAlphaLabel(0)}`;
			}

			break;
		}

		default:
			break;
	}

	return label;
}

function letterToNumber(letter) {
	return letter.toLowerCase().charCodeAt(0) - 'a'.charCodeAt(0);
}

export default getBlockLabel;
